<script setup lang="ts">
import { Head } from '@inertiajs/vue3';

// import AppearanceTabs from '@/components/AppearanceTabs.vue';
// import HeadingSmall from '@/components/HeadingSmall.vue';
// import { type BreadcrumbItem } from '@/types';

import GuestLayout from '@/layouts/GuestLayout.vue';
// import SettingsLayout from '@/layouts/settings/Layout.vue';

const breadcrumbItems: BreadcrumbItem[] = [
    {
        title: 'Appearance settings',
        href: '/settings/appearance',
    },
];
</script>

<template>
    <GuestLayout :breadcrumbs="breadcrumbItems">
        <Head title="Appearance settings" />

        <SettingsLayout>
            <div class="space-y-6">
                <HeadingSmall title="Appearance settings" description="Update your account's appearance settings" />
                <AppearanceTabs />
            </div>
        </SettingsLayout>
    </GuestLayout>
</template>
